import { render, staticRenderFns } from "./MyInfoM.vue?vue&type=template&id=423941d8&scoped=true&"
import script from "./MyInfoM.vue?vue&type=script&lang=ts&"
export * from "./MyInfoM.vue?vue&type=script&lang=ts&"
import style0 from "./MyInfoM.vue?vue&type=style&index=0&id=423941d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423941d8",
  null
  
)

export default component.exports